import React from 'react';
import Grid from "@mui/material/Grid";
import {IconButton, Typography} from "@mui/material";
import ChevronLeftTwoToneIcon from "@mui/icons-material/ChevronLeftTwoTone";
import moment from "moment";
import ChevronRightTwoToneIcon from "@mui/icons-material/ChevronRightTwoTone";
import localization from 'moment/locale/it'

const CalendarHeader = ({currentMonth, setCurrentMonth}) => {
	const nextMonth = () => {
		let newDate = new Date(currentMonth.setMonth(currentMonth.getMonth() + 1))
		setCurrentMonth(newDate);
	};
	const prevMonth = () => {
		let newDate = new Date(currentMonth.setMonth(currentMonth.getMonth() - 1))
		setCurrentMonth(newDate);
	};
	
	return (
        <React.Fragment>
            <Grid container spacing={3} direction={"row"} justifyContent={"center"}>
				<Grid item xs={12} style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
					<IconButton onClick={prevMonth} size="large">
						<ChevronLeftTwoToneIcon/>
					</IconButton>
					<Typography style={{flexGrow: 1}} align={"center"} variant={"subtitle1"}>
						<b
							style={{textTransform: "capitalize"}}>{moment(currentMonth).locale("it", localization).format("MMMM YYYY")}</b>
					</Typography>
					<IconButton onClick={nextMonth} size="large">
						<ChevronRightTwoToneIcon/>
					</IconButton>
				</Grid>
			</Grid>
        </React.Fragment>
    );
};

export default React.memo(CalendarHeader)
